import { ThemeUICSSObject } from '@apia/theme';

const menu: ThemeUICSSObject = {
  '.szh-menu': (theme) => ({
    margin: '0',
    padding: '0.5rem 0',
    listStyle: 'none',
    boxSizing: 'border-box',
    width: 'max-content',
    zIndex: 'contextMenu',
    border: '1px solid  #656565',
    backgroundColor: theme.palette.background.paper,
    userSelect: 'none',
    color: theme.palette.text.primary,
    // 'var(--theme-ui-colors-palette-text-primary)',
    borderRadius: '0.25rem',
    boxShadow: '0 3px 7px rgba(0, 0, 0, 0.133), 0 0.6px 2px rgba(0, 0, 0, 0.1)',
    minWidth: '10rem',
  }),
  '.szh-menu__arrow': (theme) => ({
    boxSizing: 'border-box',
    width: '0.75rem',
    height: '0.75rem',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid transparent',
    borderLeftColor: 'rgba(0, 0, 0, 0.1)',
    borderTopColor: 'rgba(0, 0, 0, 0.1)',
    zIndex: -1,
  }),
  '.szh-menu__arrow--dir-left': {
    right: '-0.375rem',
    transform: 'translateY(-50%) rotate(135deg)',
  },
  '.szh-menu__arrow--dir-right': {
    left: '-0.375rem',
    transform: 'translateY(-50%) rotate(-45deg)',
  },
  '.szh-menu__arrow--dir-top': {
    bottom: '-0.375rem',
    transform: 'translateX(-50%) rotate(-135deg)',
  },
  '.szh-menu__arrow--dir-bottom': {
    top: '-0.375rem',
    transform: 'translateX(-50%) rotate(45deg)',
  },
  '.szh-menu__item': {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '0.375rem 1.5rem',
    paddingLeft: '2.2rem',
    '&:has(> div.menu_item)': { paddingLeft: '10px' },
    '.menu_item': {
      padding: '0px 4px',
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',

      '.children_box': {},
      '.icon_box': {
        textAlign: 'center',
        marginTop: '3px',

        flexShrink: '0',
        width: '32px',

        '.icon': {
          marginLeft: 0,
          flexShrink: 0,
          alignSelf: 'flex-start',
        },
      },
    },
  },
  '.szh-menu__item--hover': (theme) => ({
    backgroundColor: theme.palette.background.default,
  }),
  '.szh-menu__item--focusable': {
    cursor: 'default',
  },
  '.szh-menu__item--disabled': {
    cursor: 'default',
    color: '#ccc',
  },
  '.szh-menu__group': { boxSizing: 'border-box' },
  '.szh-menu__radio-group': {
    margin: '0',
    padding: '0',
    listStyle: 'none',
  },
  '.szh-menu__divider': {
    height: '1px',
    margin: '0.5rem 0',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
  },
  '.szh-menu-button': { boxSizing: 'border-box' },
  '.szh-menu-container--itemTransition .szh-menu__item': {
    transitionProperty: 'background-color, color',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease-in-out',
  },
  '.szh-menu__item--type-radio': { paddingLeft: '2.2rem' },
  '.szh-menu__item--type-radio::before': {
    content: '"○"',
    position: 'absolute',
    left: '0.8rem',
    top: '0.55rem',
    fontSize: '0.8rem',
  },
  '.szh-menu__item--type-radio.szh-menu__item--checked::before': {
    content: '"●"',
  },
  '.szh-menu__item--type-checkbox': { paddingLeft: '2.2rem' },
  '.szh-menu__item--type-checkbox::before': {
    position: 'absolute',
    left: '0.8rem',
  },
  '.szh-menu__item--type-checkbox.szh-menu__item--checked::before': {
    content: '"✔"',
  },
  '.szh-menu__submenu.with-icon>.szh-menu__item': {
    paddingLeft: '58px',
  },
  '.szh-menu__submenu>.szh-menu__item': { paddingRight: '2.5rem' },
  '.szh-menu__submenu>.szh-menu__item::after': {
    content: '"❯"',
    position: 'absolute',
    right: '1rem',
  },
  '.szh-menu__header': {
    color: '#888',
    fontSize: '0.8rem',
    padding: '0.2rem 1.5rem',
    textTransform: 'uppercase',
  },
  '.szh-menu__item--anchor,\n.szh-menu__item--anchor:hover,\n.szh-menu__item--anchor:focus,\n.szh-menu__item--anchor:active':
    (theme) => ({
      paddingLeft: '2.2rem',
      textDecoration: 'none',
      color: theme.palette.text.primary,
    }),
};
export default menu;
